import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private tokenKey = 'ARP_Token';

  constructor(private location: Location) {}

  extractTokenFromUrl(): Promise<void> {
    return new Promise((resolve) => {
      const urlParams = new URLSearchParams(this.location.path(true).split('?')[1]);
      const token = urlParams.get('token');

      if (token) {
        sessionStorage.setItem(this.tokenKey, token);
      }

      resolve();
    });
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.tokenKey);
  }
}
